import React from 'react';

import './Loader.scss';

export function startLoader (start = true) {
  const preloader = document.getElementById('preloader') || null;
  const progressBar = document.getElementById('progressBar') || null;
  const layer = document.querySelector('.layer') || null;

  if (start) {
    preloader && preloader !== null && preloader.classList.remove('hide');
    if (progressBar && progressBar !== null) progressBar.style.transform = 'scaleX(0)';
    let w = 0;
    const t = setInterval(() => {
      w = w + 1;
      if (progressBar && progressBar !== null) {
        progressBar.style.transform = `scaleX(${
          w / 100
        }`;
      }

      // if (w === 10) {
      // layer && layer !== null && layer.classList.remove('fadeIn');
      // }

      if (w === 100) {
        clearInterval(t);
        preloader && preloader !== null && preloader.classList.add('hide');
        // layer && layer !== null && layer.classList.remove('fadeIn');
        w = 0;
      }
    }, 30);

    setTimeout(() => {
      layer && layer !== null && layer.classList.remove('fadeIn');
      window.scrollTo(0, 0);
    }, 800);
  } else {
    preloader && preloader !== null && preloader.classList.add('hide');
    layer && layer !== null && layer.classList.remove('fadeIn');
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  }
}

const Loader = (props) => {
  return (
    <div className={`loader ${props.className}`} id='preloader'>
      <img
        className='loader__img'
        src='/media/images/InClassicaColorLogo.png'
        alt='loader-logo'
      />
      <div className='loader-slide'>
        <span id='progressBar' />
      </div>
    </div>
  );
};

export default Loader;
